<template>
  <div>
    <detail-page
      :code="params.code"
      :disabled="isDisableEditForm"
      :isDisabled ="isDisableDetailForm"
      @saveOkQuestion="saveOkQuestion"
    />
  </div>
</template>
<script>
import DetailPage from "../components/detail-page"
import { mapActions } from "vuex"
export default {
  name: "purchase-packagePurchase-detail",
  components: { DetailPage },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    // 是否禁用表单
    isDisableEditForm() {
      return this.pageType === "detail" 
    },
    isDisableDetailForm() {
      return this.pageType === "add"  
    },
  },
  methods: {
    ...mapActions("admin/page", ["close"]),
    onBeforeLeave() {
      return true
    },
    saveOkQuestion() {
      this.$alert(
        this.$l("INDEX.tips_save_ok") || "保存成功",
        this.$l("INDEX.tips_question_title") || "提示信息",
        {
          confirmButtonText: "确定",
          callback: () => {
            this.closeCurPage()
          },
        }
      )
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
